import type { PracticalProject } from "../../data";

export const analyticsDashboard: PracticalProject = {
  id: "analytics-dashboard",
  num: 4,
  title: "実践プロジェクト④ ECサイト売上分析ダッシュボード — Node.js + Express + Prisma + React + Recharts で社内 BI を 1 枚作る",
  description: "主題は SQL 集計 + Recharts 可視化。JWT 認証は社内利用前提の附随インフラ (PJ#2 のパターン踏襲) で済ませて、本筋のデータ分析ダッシュボード実装に集中する",
  duration: "1〜2か月",
  techStack: ["TypeScript", "Node.js", "Express", "Prisma", "PostgreSQL", "React", "Recharts"],
  figmaUrl:
    "https://www.figma.com/design/5LLAPdI03tsb3z0ufTofP6/?node-id=834-1390",
  demoUrl:
    "https://prod-luagate-pj-dashboard-frontend-v3bbmayaea-an.a.run.app",
  starterUrl:
    "https://prod-luagate-pj-dashboard-starter-frontend-v3bbmayaea-an.a.run.app",
  repoUrl: "https://github.com/Luagate-com/luagate_pj_ec_site_dashboard",
  starterRepoUrl:
    "https://github.com/Luagate-com/luagate_pj_ec_site_dashboard/tree/starter",
  difficulty: "advanced",
  phase: "Phase 6",
  learningOutcomes: [
    "売上・在庫データを集計する SQL とデータ可視化スキルを身につける",
    "Recharts 等のチャートライブラリでダッシュボード UI を構築できるようになる",
    "JWT 認証 + RequireAuth で守られた社内ダッシュボードを開発できる発想を持てる",
    "データ分析ダッシュボードをポートフォリオに持てる",
  ],
  chapters: [
    { num: 1, title: "はじめに" },
    { num: 2, title: "ヒアリング" },
    { num: 3, title: "企画書" },
    { num: 4, title: "要件定義" },
    {
      num: 5,
      title: "基本設計",
      figmaFrames: [
        { title: "ダッシュボード画面 (メイン)", nodeId: "834-1390" },
      ],
    },
    { num: 6, title: "詳細設計" },
    { num: 7, title: "実装の進め方" },
    { num: 8, title: "7-1: 環境構築 (Codespaces + Neon + 雛形起動)" },
    { num: 9, title: "7-2: Prisma スキーマ定義と seed 投入" },
    { num: 10, title: "KPI 集計 API (/api/dashboard/summary)" },
    { num: 11, title: "月次売上 API (/api/dashboard/monthly)" },
    { num: 12, title: "週次・商品ランキング・カテゴリ集計 API" },
    {
      num: 13,
      title: "KPI カード・期間フィルタ UI (React 側)",
      figmaFrames: [
        { title: "ダッシュボード画面 (メイン)", nodeId: "834-1390" },
      ],
    },
    {
      num: 14,
      title: "折れ線グラフと棒グラフ (Recharts)",
      figmaFrames: [
        { title: "ダッシュボード画面 (メイン)", nodeId: "834-1390" },
      ],
    },
    {
      num: 15,
      title: "商品ランキング・カテゴリ円グラフ・仕上げ",
      figmaFrames: [
        { title: "ダッシュボード画面 (メイン)", nodeId: "834-1390" },
      ],
    },
    {
      num: 16,
      title: "7-9: 仕上げ・エラー境界・レスポンシブ",
      figmaFrames: [
        { title: "ダッシュボード画面 (メイン)", nodeId: "834-1390" },
      ],
    },
    { num: 17, title: "実装 FAQ (詰まったとき用)" },
    { num: 18, title: "テスト・提出" },
    { num: 19, title: "用語ミニ辞書" },
  ],
};
